// styles.tsx
import styled from 'styled-components';
import { newNormalizeHeight, newNormalizeWidth, normalizeHeight, normalizeHeightToVH, normalizeWidthToVW } from '../../utils/normalize';

export const InputContainer = styled.div`
  display: flex;
  gap: 8px;
  padding-left: 16px;
  padding-right: 16px;
  border-radius: 8px;
  background-color: #F5F5F5;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const Input = styled.input`
  height: ${normalizeHeight(42)};
  border: none;
  background-color: transparent;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 125%;
  color: #A0A0A0;
  outline: none;
`;